// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'
import prophyStatus from './modules/prophyStatus'
import questionnaire from './modules/questionnaire'
import memoryRecallHint from './modules/memoryRecallHint'
import globalLocalizationStrings from './localization/globalLocalizationStrings'
import recurringStudiesList from './recurringStudiesList'

Vue.use(Vuex)
Vue.use(VueResource)

const store = new Vuex.Store({
  modules: {
    prophyStatus: prophyStatus,
    questionnaire: questionnaire,
    memoryRecallHint: memoryRecallHint
  },
  state: {
    userLang: null,
    userCountry: null,
    userId: null,

    userChronicity: null,
    userMigraineYears: null,
    userProphy: null,

    userAuthToken: null,

    recurringStudies: recurringStudiesList,

    mergedUserAnswers: {},
    qnResponseOverall: [],
    baseResponseOverall: [],
    recurringResponseOverall: []
  },
  getters: {
    localization: (state) => {
      return globalLocalizationStrings[state.userLang]
    },
    locale: (state) => {
      return (state.userLang + '-' + state.userCountry)
    },
    authUrl: (state) => {
      return process.env.AUTH_URL + state.userId
    },
    postAnswerUrl: (state) => {
      return process.env.API_URL + 'answer'
    },
    nextSurvey: (state) => {
      return state.qnResponseOverall.find(questionnaire => questionnaire.answered === false)
    },
    processedRecurringResponseOverall: (state) => {
      let temp = []

      for (let i = 0; i < state.recurringResponseOverall.length; i++) {
        let response = state.recurringResponseOverall[i]

        let recentElapsedMonth = null
        let daysToNextInput = null
        let startDate = null
        let molecule = null
        let dosage = null
        let endDate = null
        let lastCompletedMonth = null

        if (response.max_order_answered_meta !== null && typeof response.max_order_answered_meta === 'object') {
          let meta = response.max_order_answered_meta

          molecule = meta.hasOwnProperty('prophy') ? meta.prophy : null
          dosage = meta.hasOwnProperty('dosage') ? meta.dosage : null
          endDate = meta.hasOwnProperty('end_date') ? meta.end_date : null
          lastCompletedMonth = meta.hasOwnProperty('recurring_order') ? parseInt(meta.recurring_order) : null

          if (meta.hasOwnProperty('start_date')) {
            startDate = meta.start_date

            let baselineTime = new Date(state.recurringResponseOverall[i].max_order_answered_meta.start_date.substr(0, 10)).getTime()
            let nowTime = new Date().getTime()
            let thirtyDaysDiff = (nowTime - baselineTime) / (86400000 * 30)
            recentElapsedMonth = Math.floor(thirtyDaysDiff);
            daysToNextInput = 30 - Math.floor(((nowTime - baselineTime) % (86400000 * 30)) / 86400000)
          }
        }

        // Note: this only refers to completed month
        // TODO: Validate some structure. throw err if things fail!
        temp.push({
          study: state.recurringResponseOverall[i].study,
          molecule,
          dosage,
          startDate,
          endDate,
          recentElapsedMonth: recentElapsedMonth,
          lastCompletedMonth,
          daysToNextInput: daysToNextInput,
          'baseline_start_date': state.recurringResponseOverall[i].baseline_start_date,
          'nb_baseline_answers': state.recurringResponseOverall[i].nb_baseline_answers
        })
      }

      return temp;
    }
  },
  mutations: {
    setQnResponseOverall: (state, payload) => {
      state.qnResponseOverall = payload.reverse()
    },
    setRecurringResponseOverall: (state, payload) => {
      let output = []

      for (let i in payload) {
        /// urgh
        for (let y in state.recurringStudies) {
          if (state.recurringStudies[y].studyName === payload[i].study_name) {
            let study = payload[i]
            study.study = state.recurringStudies[y]
            output.push(study)
          }
        }
      }

      state.recurringResponseOverall = output
    },
    setUserProfile: (state, payload) => {
      // Fallback to EN when we don't have stuff in the other language
      let acceptableLangList = ['en', 'fr', 'es', 'it', 'pt', 'ko', 'nl', 'de', 'ja']
      if (acceptableLangList.indexOf(payload.userLang) > -1) {
        state.userLang = payload.userLang
      } else {
        state.userLang = 'en'
      }
      state.userCountry = payload.userCountry
      state.userId = payload.userId
    },
    setUserAuthToken: (state, payload) => {
      state.userAuthToken = payload
    },
    setMergedUserAnswers: (state, payload) => {
      state.mergedUserAnswers = payload
    },
    setUserSegmentation: (state, payload) => {
      state.userChronicity = payload.chronicity
      state.userMigraineYears = payload['migraine_years']
      state.userProphy = payload.prophy
    }
  },
  actions: {
    updateUserProfile ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setUserProfile', payload)
        resolve()
      })
    },
    updateUserAuthToken ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setUserAuthToken', payload)
        resolve()
      })
    },
    updateMergedUserAnswers ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setMergedUserAnswers', payload)
        resolve()
      })
    },
    updateQnResponseOverall ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setQnResponseOverall', payload)
        resolve()
      })
    },
    updateRecurringResponseOverall ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setRecurringResponseOverall', payload)
        resolve()
      })
    },
    updateUserSegmentation ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setUserSegmentation', payload)
        resolve()
      })
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js